import request from 'sb-request'
import { reducers } from 'redux/core'


const fetchItems = () => {
  reducers.view.sentGiftsPage.setFetchingStatus(true)

  request.get('rest/gifts/sent')
    // TODO ask backend to remove `gifts` key from response
    .then(
      ({ gifts: result }) => reducers.view.sentGiftsPage.setItems(result),
      () => {
        reducers.view.sentGiftsPage.setFetchingStatus(false)
        return Promise.reject()
      }
    )
}

const reset = reducers.view.sentGiftsPage.reset // eslint-disable-line


export default {
  reset,
  fetchItems,
}
